import {Component, computed, effect, input, output} from '@angular/core';
import {TaListBase} from '../../../pages/ta-list-base.directive';
import {BasicTaDetails} from '../../../../api';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {Button} from 'primeng/button';
import {DatePipe, NgClass} from '@angular/common';
import {DelegateTaMode, canCreateTemplateFrom, toTAStatusText} from '../../../../util/app.types';
import {Chip} from 'primeng/chip';
import {LocationService} from '../../../../services/location.service';
import {InputText} from 'primeng/inputtext';
import {PrepaidIndicatorComponent} from '../../prepaid-indicator/prepaid-indicator.component';
import {AttachmentIndicatorComponent} from '../../attachment-indicator/attachment-indicator.component';
import {TaCommentCount} from '../../ta-comments/ta-comment-count';

@Component({
  selector: 'delegate-ta-list',
  imports: [
    TaCommentCount,
    Button,
    Chip,
    DatePipe,
    InputText,
    ReactiveFormsModule,
    TableModule,
    FormsModule,
    NgClass,
    PrepaidIndicatorComponent,
    AttachmentIndicatorComponent,
  ],
  templateUrl: './delegate-ta-list.component.html',
  host: {class: 'block min-h-0 min-w-0'},
})
export class DelegateTaListComponent extends TaListBase {
  mode = input.required<DelegateTaMode>();
  createTemplate = output<BasicTaDetails>();

  cache = computed(() => this.mode() === 'active'
    ? this.store.delegateActiveTaListCache()
    : this.store.delegateClosedTaListCache());
  isLoading = computed(() => this.mode() === 'active'
    ? this.store.delegateActiveLoading()
    : this.store.delegateClosedLoading());

  heading = computed(() => this.mode() === 'active' ? 'Active Booking Officer TAs' : 'Closed Booking Officer TAs');
  emptyMessage = computed(() => this.mode() === 'active'
    ? 'You have no active TAs raised on behalf of another traveller.'
    : 'You have no closed TAs raised on behalf of another traveller.');

  canLoadMore = computed(() => {
    const cache = this.cache();
    if (!cache || !cache.totalCount) return false;
    return (cache.currentCount ?? 0) < cache.totalCount;
  });

  constructor(
    protected locationService: LocationService,
  ) {
    super();

    effect(() => {
      this.availableTaList.set(this.cache()?.taList ?? []);
    });
  }

  // The loader decides whether to refetch - it reuses a cache newer than LIST_CACHE_TTL_MS.
  override ngOnInit() {
    super.ngOnInit();
    this.taSearchDatasource.loadDelegateTaList(this.mode());
  }

  reloadTaList(): void {
    this.store.resetDelegateCache(this.mode());
    this.taSearchDatasource.loadDelegateTaList(this.mode());
  }

  loadMore(): void {
    if (!this.canLoadMore() || this.isLoading()) return;
    this.taSearchDatasource.loadMoreDelegateTas(this.mode());
  }

  protected readonly toTAStatusText = toTAStatusText;
  protected readonly canCreateTemplateFrom = canCreateTemplateFrom;
}
